import Vue from 'vue';
import NuxtJsonld from 'nuxt-jsonld';

const DEFAULT_MODE = 2;

Vue.use(NuxtJsonld);
Vue.use(NuxtJsonld, {
	space: process.env.NODE_ENV === 'production' ? 0 : DEFAULT_MODE,
});
